import { render, staticRenderFns } from "./PostingFailures.vue?vue&type=template&id=74e9975a"
import script from "./PostingFailures.vue?vue&type=script&lang=js"
export * from "./PostingFailures.vue?vue&type=script&lang=js"
import style0 from "./PostingFailures.vue?vue&type=style&index=0&id=74e9975a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports